import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import ConditionListGather from 'Component/pages/components/check-point-condition-list-gather';

interface TemplateProps extends Record<string, any> {
    value?: any;
    onChange?: (v: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, ...restProps } = props;

    return (
        <ConditionListGather
            type={[0]}
            ruglar
            isAutoAssociateDateSource={0}
            replenishOperatorTypes={(showList, operatorTypes) => {
                const index = showList.findIndex((item) => item.id === 13);
                if (index > -1) {
                    showList.splice(index, 1, Udesk.enums.operatorTypes.associate);
                }
                const businessSummaryIndex = showList.findIndex((item) => item.id === 34);
                if (businessSummaryIndex > -1) {
                    showList.splice(businessSummaryIndex, 1);
                }
            }}
            replenishConditionTypes={(showList, list) => {
                showList.push(list[3]); // 添加信息模块;
            }}
            showSmartModelType // 添加模型模块
            conditionList={value}
            onChange={onChange}
            {...restProps}
        />
    );
});

export default Template;
